// extracted by mini-css-extract-plugin
module.exports = {"mtSmall":"KeihinBody_mtSmall__1b8yb","textHtml":"KeihinBody_textHtml__h2u4H","textSmall":"KeihinBody_textSmall__2S_uh"};